import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("opplio_user") || "null"); } catch { return null; }
  });
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(false);

  const persist = (token, u) => {
    localStorage.setItem("opplio_token", token);
    localStorage.setItem("opplio_user", JSON.stringify(u));
    setUser(u);
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    persist(data.token, data.user);
    return data;
  };

  const register = async (email, password, full_name) => {
    const { data } = await api.post("/auth/register", { email, password, full_name });
    persist(data.token, data.user);
    return data;
  };

  const loginWithGoogle = async (credential, mode = "login") => {
    const { data } = await api.post("/auth/google", { credential, mode });
    persist(data.token, data.user);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("opplio_token");
    localStorage.removeItem("opplio_user");
    setUser(null);
    setProfile(null);
  };

  const refreshProfile = async () => {
    if (!localStorage.getItem("opplio_token")) return null;
    try {
      const { data } = await api.get("/auth/me");
      setProfile(data.profile || null);
      if (data.user) {
        localStorage.setItem("opplio_user", JSON.stringify(data.user));
        setUser(data.user);
      }
      return data;
    } catch {
      return null;
    }
  };

  useEffect(() => {
    if (user && !profile) { refreshProfile(); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AuthCtx.Provider value={{ user, profile, setProfile, login, register, loginWithGoogle, logout, refreshProfile, loading, setLoading }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
